class PasBeforeAfter extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.frame = this.querySelector('[data-before-after-frame]');
    this.input = this.querySelector('[data-before-after-input]');
    this.frame?.addEventListener('pointerdown', (event) => {
      this.frame.setPointerCapture?.(event.pointerId);
      this.setFromPointer(event.clientX);
    });
    this.frame?.addEventListener('pointermove', (event) => {
      if (event.buttons === 1) this.setFromPointer(event.clientX);
    });
    this.input?.addEventListener('input', () => this.setPosition(Number(this.input.value)));
    this.setPosition(Number(this.input?.value || 50));
  }

  setFromPointer(clientX) {
    const bounds = this.frame?.getBoundingClientRect();
    if (!bounds?.width) return;
    this.setPosition(((clientX - bounds.left) / bounds.width) * 100);
  }

  setPosition(value) {
    const position = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 50));
    this.style.setProperty('--pas-before-position', `${position}%`);
    if (this.input) this.input.value = String(Math.round(position));
  }
}

class PasProductFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-faq-button]') : null;
      if (!button || !this.contains(button)) return;
      const item = button.closest('[data-faq-item]');
      const open = item?.classList.toggle('is-open') || false;
      button.setAttribute('aria-expanded', String(open));
      item?.querySelector('[data-faq-panel]')?.setAttribute('aria-hidden', String(!open));
    });
  }
}

if (!customElements.get('pas-before-after')) customElements.define('pas-before-after', PasBeforeAfter);
if (!customElements.get('pas-product-faq')) customElements.define('pas-product-faq', PasProductFaq);

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('[data-story-reveal]');
  if (!reducedMotion && typeof IntersectionObserver !== 'undefined') {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((element) => {
      element.classList.add('is-reveal-ready');
      revealObserver.observe(element);
    });
  }

  const nav = document.querySelector('[data-product-section-nav]');
  if (!nav || typeof IntersectionObserver === 'undefined') return;
  const observedTargets = new WeakSet();
  const sectionObserver = new IntersectionObserver((entries) => {
    const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (!visible[0]) return;
    const activeId = visible[0].target.id;
    nav.querySelectorAll('a[href^="#"]').forEach((link) => {
      const active = link.getAttribute('href') === `#${activeId}`;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
  }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
  const observeTargets = () => {
    nav.querySelectorAll('a[href^="#"]').forEach((link) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target || observedTargets.has(target)) return;
      observedTargets.add(target);
      sectionObserver.observe(target);
    });
  };
  observeTargets();
  document.addEventListener('pas:navigation-updated', observeTargets);
})();
